
import Vue from "vue";
export default Vue.extend({
  name: "learn-more",
  props: {
    content: { type: String, default: "" },
    contentLong: { type: String, default: "" },
    long: { type: Boolean, default: false },
  },
});
